import { Auth } from '@finx/web-repository/src/services/Oidc'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import _ from 'lodash'
import { timeout, getUser } from '@/utils/common'

@Module({ namespaced: true, name: 'BackofficeNavigationStore' })
export default class BackofficeNavigationStore extends VuexModule {
  private navigationDrawerDefault: boolean | null = null
  private miniSyncDefault: boolean = false

  public navigationDrawer: boolean | null = this.navigationDrawerDefault
  public miniSync: boolean = this.miniSyncDefault

  @Mutation
  setNavigationDrawer(value: boolean | null) {
    this.navigationDrawer = value
  }

  @Mutation
  setMiniSync(value: boolean) {
    this.miniSync = value
  }

  @Mutation
  clearNavigationDrawer() {
    this.navigationDrawer = this.navigationDrawerDefault
  }

  @Mutation
  clearMiniSync() {
    this.miniSync = this.miniSyncDefault
  }
}
